module.exports = "data:image/png;base64,"